module.exports = __webpack_public_path__ + "media/images/tdri-logo-680268e6cd642c4c867d6fc102d65634.png";